import React, { useMemo, useEffect, useState } from "react";
import { Spinner, Flex, Image } from "@chakra-ui/react";
import { Column } from "react-table";

import api from "services/api"; 

import { Table } from "./Table";
import { useCustomToast } from "hooks/useToast";
import { _t } from "content";
import dayjs from "dayjs";

export const TableCupons = () => {

  const inicio = dayjs().subtract(180, "day").format("YYYY-MM-DD");
  const final = dayjs().format("YYYY-MM-DD");

  const { getToast } = useCustomToast();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any>([]); 
  const [startDate, setStartDate] = useState<string>(inicio);
  const [endDate, setEndDate] = useState<string>(final);

  const getDados = async () => {
    setLoading(true)
    // StatusId

    try {

      const request = {
        dataDe: startDate,
        dataAte: endDate
      } 
      const {data} = await api.post('/produto/notaFiscal/pesquisar', request)
      setRows(data)
      
    } catch (error) {
      console.log(error)
      getToast({
        messageError: "falha ao buscar cupons",
        status: "warning",
      }); 
    } finally {
      setLoading(false)
    }
     
  }

  useEffect(() => {
    getDados()
  }, [])


  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: "detalhe",
        accessor: "id",
      },
      {
        Header: "cupom",
        accessor: "id",
      },
      {
        Header: "Data",
        accessor: "dataInclusao",
      },
      {
        Header: "Status",
        accessor: "mensagemStatus",
      },
      {
        Header: "status",
        accessor: "processamentoStatus"
      },
    ],
    []
  );
  return (
    <>
      {loading ? (
        <Flex margin="0px auto" justifyContent="center">
          <Spinner color={_t.color2} />
        </Flex>
      ) : (
        <>  
        <Table
          columns={columns}
          data={rows ?? []}
        />
        </>
      )}
    </>
  );
};
